import { css } from '@fable/theme'
import { useStreakCalendarGrid } from './useStreakCalendarGrid'
import { StreakCalendarCell } from './StreakCalendarCell'
import { StreakCalendarGridHeader } from './StreakCalendarGridHeader'
import { StreakCalendarMotion } from './StreaksCalendarMotion'
import { useStreakCell } from './useStreakCell'

interface Props {
  animate?: boolean
  inView?: boolean
}

export const StreakCalendarGrid = ({
  animate = false,
  inView = false,
}: Props) => {
  const grid = useStreakCalendarGrid()
  const { getStreakCell } = useStreakCell()

  return (
    <div
      className={css`
        padding: ${animate ? '16px' : 0} 0 20px;
      `}
    >
      <StreakCalendarGridHeader />
      <div
        className={css`
          width: 100%;
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          grid-auto-rows: 52px;
          gap: 6px;
        `}
      >
        {grid.map((cell, i) => {
          const streakProps = getStreakCell(cell)

          return animate ? (
            <StreakCalendarMotion
              transition={{ duration: 0.5, delay: i * 0.02 }}
              key={i}
              inView={inView}
            >
              <StreakCalendarCell {...cell} {...streakProps} animate />
            </StreakCalendarMotion>
          ) : (
            <StreakCalendarCell key={i} {...cell} {...streakProps} />
          )
        })}
      </div>
    </div>
  )
}
